import api from "../../../../api";
import React, { useEffect, useState } from "react";
import values from "../../../../values";
import Context from "../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import { ICityItem, IProvinceItem } from "../../../../types/common.interface";
import {
  CustomButton2,
  CustomDropdownSearch,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";

import "./index.sass";
import TitleLine from "../../../../components/TitleLine";
import validations from "../../../../validations";
import utils from "../../../../utils";
import { ICreateAndUpdateGovernmentShip } from "../../../../types/govenmentShip.interface";
import { useTranslation } from "react-i18next";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const {
    showModal,
    setShowModal,
    updateFunction,
    isLoading,
    selectedGovernmentShip,
  } = React.useContext(Context.GovernmentShipScreen);
  const [selectedProvince, setSelectedProvince] =
    React.useState<IProvinceItem>();
  const [dropDownErrors, setDropDownErrors] = useState<any>({
    province: "",
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  useEffect(() => {
    setSelectedProvince(
      selectedGovernmentShip?.governmentShipInformation?.province
    );
  }, [selectedGovernmentShip]);

  const formik = useFormik<ICreateAndUpdateGovernmentShip>({
    enableReinitialize: true,
    initialValues: {
      _id: selectedGovernmentShip?._id ? selectedGovernmentShip._id : "",
      name: selectedGovernmentShip?.governmentShipInformation?.name
        ? selectedGovernmentShip?.governmentShipInformation?.name
        : "",
      phoneNumber: selectedGovernmentShip?.phoneNumber
        ? "0" + selectedGovernmentShip.phoneNumber
        : "",
    },
    validationSchema: Yup.object({
      // validation
      name: validations.yupValidations.firstName,
      phoneNumber: validations.yupValidations.phoneNumber,
    }),
    onSubmit: (values: ICreateAndUpdateGovernmentShip, { setSubmitting }) => {
      // if (!selectedProvince) return utils.errorHandler(9011);
      // if (!selectedCity) return utils.errorHandler(9012);
      const formValues: ICreateAndUpdateGovernmentShip = {
        ...values,
        province: selectedProvince,
      };
      if (selectedProvince) {
        Promise.resolve(updateFunction(formValues))
          .then((value) => {
            if (value) {
              setSelectedProvince(undefined);
            }
          })
          .catch((e) => setSubmitting(false));
      }
    },
  });

  const { t } = useTranslation();

  function submitHandler() {
    // validation

    let errors = {};
    if (!selectedProvince) {
      errors = {
        ...errors,
        province: t("province_is_required"),
      };
    }

    setDropDownErrors({
      ...errors,
    });

    formik.submitForm();
  }

  function closeHandler() {
    setShowModal("NONE");
  }

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "UPDATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">{t("province")}</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) => {
                    setSelectedProvince(event);
                    setDropDownErrors({ ...dropDownErrors, province: "" });
                  }}
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
                <div className="error">
                  {dropDownErrors.province !== "" && dropDownErrors.province}
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="name"
                  id="name"
                  label={t("name")}
                  value={formik.values.name}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>{" "}
              <CustomView.Column medium={6} className="form-colum">
                {""}
              </CustomView.Column>
            </CustomView.Row>

            {/* <TitleLine title="اطلاعات مسئول مربوطه" /> */}

            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={closeHandler}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("update")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Update;
